// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3LlsF","name":"styles_name__fofAx","phone":"styles_phone__26opA"};